import * as R from 'ramda';
import React, {Component} from 'react';
import gqlClient from 'js/graphql/client/gqlClient';
import {campaignStorySegmentDistMetrics as query} from 'js/graphql/queries/campaign_story_segment_dist_metrics';

import {prettyNumber} from 'js/common/string_helper';

import {AnalyticsCard} from 'js/common/campaign_analytics_helper';
import reachIcon from 'images/admin/campaign_analytics/icons/reach.png';
import commentIcon from 'images/admin/campaign_analytics/icons/comment.png';

export default class StoryAnalyticsCards extends Component {
    static defaultProps = {
        children: R.identity
    };

    constructor() {
        super();

        this.state = {
            fetchedStoryMetrics: true,

            /** Hits is the number of documents we have for this search. */
            hits: 0,
            totalExits: 0,
            totalImpressions: 0,
            totalReach: 0,
            totalReplies: 0,
            totalTapsForward: 0,
            totalTapsBack: 0
        };
    }

    componentDidMount() {
        this.fetchStoryMetrics();
    }

    fetchStoryMetrics = async () => {
        try {
            const {data} = await gqlClient.client.query({
                query,
                variables: {
                    campaignId: R.path(['sn', 'analyticsData', 'campaign_id'], window),
                    esSearchBody: JSON.stringify({
                        size: 0,
                        query: {bool: {must: [{match: {version: 1}}]}},
                        aggs: {
                            impressions: {
                                filter: {range: {impressions: {gte: 0}}},
                                aggs: {sum: {sum: {field: 'impressions'}}}
                            },
                            reach: {
                                filter: {
                                    range: {
                                        reach: {
                                            gte: 0
                                        }
                                    }
                                },
                                aggs: {
                                    uniq_by_social_account_ids: {
                                        terms: {
                                            field: 'social_account_id',
                                            size: 10000
                                        },
                                        aggs: {
                                            max_reach: {
                                                max: {
                                                    field: 'reach'
                                                }
                                            }
                                        }
                                    },
                                    sum: {
                                        sum_bucket: {
                                            buckets_path: 'uniq_by_social_account_ids>max_reach'
                                        }
                                    }
                                }
                            },
                            replies: {
                                filter: {range: {replies: {gte: 0}}},
                                aggs: {sum: {sum: {field: 'replies'}}}
                            },
                            taps_forward: {
                                filter: {range: {taps_forward: {gte: 0}}},
                                aggs: {sum: {sum: {field: 'taps_forward'}}}
                            },
                            taps_back: {
                                filter: {range: {taps_back: {gte: 0}}},
                                aggs: {sum: {sum: {field: 'taps_back'}}}
                            },
                            exits: {
                                filter: {range: {exits: {gte: 0}}},
                                aggs: {sum: {sum: {field: 'exits'}}}
                            }
                        }
                    })
                }
            });

            const aggResult = R.pipe(
                R.path(['campaign', 'distributionMetricSearch', 'rawSearchResult']),
                JSON.parse
            )(data);

            const aggregations = R.path(['aggregations'], aggResult);

            this.setState({
                fetchedStoryMetrics: true,
                hits: R.pathOr(0, ['hits', 'total'], aggResult),
                totalReach: R.pathOr(0, ['reach', 'sum', 'value'], aggregations),
                totalImpressions: R.pathOr(0, ['impressions', 'sum', 'value'], aggregations),
                totalReplies: R.pathOr(0, ['replies', 'sum', 'value'], aggregations)
            });
        } catch (error) {
            console.error(error);
            this.setState({fetchedStoryMetrics: false});
        }
    };

    render() {
        if (!this.state.fetchedStoryMetrics) {
            return null;
        }

        /** If there were no documents, render nothing. */
        if (!this.state.hits) {
            return null;
        }

        const cards = [
            {
                stateName: 'totalReach',
                label: 'Story Reach',
                description:
                    'Total number of unique views across all stories, calculated by summing the maximum reach for each creator in the campaign.',
                icon: reachIcon
            },
            {
                stateName: 'totalImpressions',
                label: 'Story Impressions',
                description: 'Total number of times stories in the campaign were viewed.',
                icon: reachIcon
            },
            {
                stateName: 'totalReplies',
                label: 'Story Replies',
                description: 'Total number of replies to the stories in the campaign from viewers.',
                icon: commentIcon
            }
        ]
            .filter(({stateName}) => typeof this.state[stateName] === 'number')
            .map((metric) => (
                <AnalyticsCard
                    label={metric.label}
                    data={prettyNumber(this.state[metric.stateName])}
                    icon={metric.icon}
                    helpText={metric.description}
                    tooltipColor="light"
                    place="top"
                    multiline
                    inline
                />
            ));

        return <div>{this.props.children(cards)}</div>;
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/analytics/story_analytics_cards.js